import { render, staticRenderFns } from "./CardStaffItem.vue?vue&type=template&id=155a686d&scoped=true"
import script from "./CardStaffItem.vue?vue&type=script&lang=js"
export * from "./CardStaffItem.vue?vue&type=script&lang=js"
import style0 from "./CardStaffItem.vue?vue&type=style&index=0&id=155a686d&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155a686d",
  null
  
)

export default component.exports